import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import {
  ROBOTS_PAGE_PATH,
  SITEMAP_PAGE_ADD_PATH,
  SITEMAP_PAGE_PATH,
  SITEMAP_PAGE_UPDATE_PATH,
} from "utils/constants/paths";

const SitemapPage = Loadable(React.lazy(() => import("./View")));
const SitemapPageAddOrUpdate = Loadable(
  React.lazy(() => import("./View/AddOrUpdate")),
);
const RobotsPage = Loadable(React.lazy(() => import("./View/Robots")));

export const SitemapRoute: IRouteItem = {
  path: SITEMAP_PAGE_PATH,
  element: React.createElement(SitemapPage),
  name: "Sitemap",
  children: [
    {
      name: "Add / Update",
      path: SITEMAP_PAGE_ADD_PATH,
      element: React.createElement(SitemapPageAddOrUpdate),
      showInDrawer: false,
    },
    {
      path: SITEMAP_PAGE_UPDATE_PATH,
      element: React.createElement(SitemapPageAddOrUpdate),
      showInDrawer: false,
    },
  ],
};

export const RobotsRoute: IRouteItem = {
  path: ROBOTS_PAGE_PATH,
  element: React.createElement(RobotsPage),
  name: "Robots.txt",
};
